import { SDK, ServerOptions } from '@commercetools/frontend-sdk';
import { callActionMiddleware } from '@/helpers/utils/callActionHelper';
import { GetEntryAction, GetContentByTitleAction } from '../../types/actions/ContentstackAction';
import { ComposableCommerceEvents } from '../../types/events/ComposableCommerceEvents';

export type ContenstackActions = {
  getEntry: GetEntryAction;
  getContentByTitleOnly: GetContentByTitleAction;
};

export const getContenstackActions = (sdk: SDK<ComposableCommerceEvents>): ContenstackActions => {
  return {
    getEntry: async (payload: string, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<unknown>({
        actionName: 'contentstack/getEntry',
        query: { contentTypeUid: payload },
        serverOptions: options.serverOptions,
      });
      return response;
    },
    getContentByTitleOnly: async (payload: object, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<unknown>({
        actionName: 'contentstack/getContentByTitleOnly',
        query: { ...payload },
        serverOptions: options.serverOptions,
      });
      return response;
    },
  };
};
